import { render, staticRenderFns } from "./PageUserProfile.vue?vue&type=template&id=62e6b552&"
import script from "./PageUserProfile.vue?vue&type=script&lang=js&"
export * from "./PageUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./PageUserProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports